import api from '@/api.js';
const state = {
    faces: 'UUUUUUUUURRRRRRRRRFFFFFFFFFDDDDDDDDDLLLLLLLLLBBBBBBBBB',
    moves: ''
};
const mutations = {
    setFaces(state, s) {
        state.faces = s;
    },
    setMoves(state, m) {
        state.moves = m;
    }
};
const getters = {
    faces: (state) => state.faces,
    moves: (state) => state.moves
};
const actions = {
    async reset({ commit }) {
        commit('setFaces', 'UUUUUUUUURRRRRRRRRFFFFFFFFFDDDDDDDDDLLLLLLLLLBBBBBBBBB');
    },
    async move({ commit }, { facelets, moves }) {
        const res = await api.rubik.move(facelets, moves);
        commit('setMoves', res.data.moves);
        commit('setFaces', res.data.facelets);
        return res;
    },
    async shuffle({ commit }, { facelets }) {
        console.log('shuffle', facelets);
        const res = await api.rubik.shuffle(facelets);
        console.log(res);
        commit('setMoves', res.data.moves);
        commit('setFaces', res.data.facelets);
        return res;
    },
    async verify({ commit }, facelets) {
        const res = await api.rubik.verify(facelets);
        console.log('facelets.verify', res.data);
        return res.data;
    },
    async solve({ commit }, facelets) {
        console.log('facelets', facelets);
        const res = await api.rubik.solve(facelets);
        console.log('facelets.solved', res.data);
        commit('setMoves', res.data.moves);
        commit('setFaces', res.data.facelets);
        return res;
    }
};
export const Rubik = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
